/* Progressive enhancement: original select remains the submitted, required field. */
(() => {
  function enhance(select) {
    if (select.dataset.enhanced) return;
    select.dataset.enhanced = 'true';
    const label = select.closest('label');
    const wrapper = document.createElement('div');
    wrapper.className = 'pv-select';
    label.after(wrapper);
    wrapper.append(label, select);
    select.classList.add('pv-select__native');
    select.tabIndex = -1;
    select.setAttribute('aria-hidden', 'true');
    const trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.id = `${select.id}-trigger`;
    trigger.className = 'pv-select__trigger';
    trigger.setAttribute('role', 'combobox');
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-expanded', 'false');
    trigger.setAttribute('aria-required', String(select.required));
    label.id = `${select.id}-label`;
    label.htmlFor = trigger.id;
    trigger.setAttribute('aria-labelledby', `${label.id} ${trigger.id}`);
    const list = document.createElement('div');
    list.id = `${select.id}-options`;
    list.className = 'pv-select__options';
    list.setAttribute('role', 'listbox');
    list.setAttribute('aria-labelledby', label.id);
    list.hidden = true;
    trigger.setAttribute('aria-controls', list.id);
    const options = [...select.options].filter(option => option.value && !option.disabled);
    let active = 0;
    let search = '';
    let searchedAt = 0;
    const rows = options.map((option, index) => {
      const row = document.createElement('div');
      row.id = `${select.id}-option-${index}`;
      row.className = 'pv-select__option';
      row.setAttribute('role', 'option');
      row.textContent = option.textContent;
      row.addEventListener('pointerdown', event => event.preventDefault());
      row.addEventListener('click', () => choose(index));
      list.append(row);
      return row;
    });
    wrapper.append(trigger, list);
    function sync() {
      trigger.textContent = select.selectedOptions[0]?.textContent || select.options[0]?.textContent || '';
      trigger.classList.toggle('is-placeholder', !select.value);
      rows.forEach((row, index) => row.setAttribute('aria-selected', String(options[index].value === select.value)));
      if (select.validity.valid) trigger.removeAttribute('aria-invalid');
    }
    function highlight(index) {
      active = (index + options.length) % options.length;
      rows.forEach((row, i) => row.classList.toggle('is-active', i === active));
      trigger.setAttribute('aria-activedescendant', rows[active].id);
      rows[active].scrollIntoView({block: 'nearest'});
    }
    function close() {
      list.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
      trigger.removeAttribute('aria-activedescendant');
    }
    function open() {
      list.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      highlight(Math.max(0, options.findIndex(option => option.value === select.value)));
    }
    function choose(index) {
      select.value = options[index].value;
      select.dispatchEvent(new Event('input', {bubbles: true}));
      select.dispatchEvent(new Event('change', {bubbles: true}));
      sync(); close(); trigger.focus();
    }
    trigger.addEventListener('click', () => list.hidden ? open() : close());
    trigger.addEventListener('keydown', event => {
      if (event.ctrlKey || event.metaKey || event.altKey) return;
      if (event.key === 'Tab') { close(); return; }
      if (event.key === 'Escape') { if (!list.hidden) event.preventDefault(); close(); return; }
      if (['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) {
        event.preventDefault();
        if (list.hidden) open();
        else highlight(event.key === 'Home' ? 0 : event.key === 'End' ? options.length - 1 : active + (event.key === 'ArrowDown' ? 1 : -1));
      } else if ((event.key === 'Enter' || event.key === ' ') && !list.hidden) {
        event.preventDefault(); choose(active);
      } else if (event.key.length === 1 && event.key !== ' ' && !event.ctrlKey && !event.metaKey) {
        event.preventDefault();
        search = Date.now() - searchedAt > 700 ? event.key : search + event.key;
        searchedAt = Date.now();
        if (list.hidden) open();
        const index = options.findIndex(option => option.textContent.toLocaleLowerCase('ro').startsWith(search.toLocaleLowerCase('ro')));
        if (index >= 0) highlight(index);
      }
    });
    wrapper.addEventListener('focusout', event => { if (!wrapper.contains(event.relatedTarget)) close(); });
    document.addEventListener('pointerdown', event => { if (!wrapper.contains(event.target)) close(); });
    select.addEventListener('invalid', event => {
      event.preventDefault();
      trigger.setAttribute('aria-invalid', 'true');
      const first = select.form.querySelector(':invalid');
      if (first === select) { trigger.focus(); open(); }
    });
    select.addEventListener('change', sync);
    select.form.addEventListener('reset', () => setTimeout(() => { sync(); close(); }, 0));
    sync();
  }
  const init = () => document.querySelectorAll('.pv-installation__form select').forEach(enhance);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();
